const CONFIG = {
  //开发环境配置
  development: {
    // baseUrl: 'http://192.168.8.29:8010', // 后台接口请求地址
    // baseUrl: 'http://192.168.8.29:8089', // 后台接口请求地址
    // baseUrl: 'https://ehis.e-rijiben.com', // 销售人员内部使用包括测试演示等用处
    // baseUrl: 'http://192.168.8.23:8089', // 后台接口请求地址
    // baseUrl: 'http://192.168.8.10:8089', // 后台接口请求地址
    // baseUrl: 'http://192.168.8.102:8089', // 后台接口请求地址
    baseUrl: 'https://foacc.8218ai.com', // 对外
    // baseUrl: 'https://sitapi.8218ai.com', // 测试后台接口请求地址
    // baseUrl: "http://192.168.8.23:8089"
  },
  //生产环境配置 
  production: {
    // baseUrl: 'https://ehis.e-rijiben.com', // 销售人员内部使用包括测试演示等用处
    baseUrl: 'https://sitapi.8218ai.com', // 测试后台接口请求地址
    // baseUrl: 'https://foacc.8218ai.com', // 对外
  }
};
export default CONFIG[process.env.NODE_ENV];